import { useSelectedProductTypesContext } from '~src/context/selectedProductTypeContext';
import { getCombinedFinancing } from '~src/hooks/useGenericFinancing';
import { DeepPartial, Loan, OfferProducts, ProductType, Residence } from '~src/model';
import { getOutputArrayFilteredByProductType } from '~src/util';

import { useGenericFinancing } from './useGenericFinancing';

type GenericCombinedFinancingParameters = {
  offer?: DeepPartial<OfferProducts>;
  residence?: DeepPartial<Residence>;
  heatPumpLoan: Loan;
  solarLoan: Loan;
  selectedProductTypes?: ProductType[];
  calculationMethod?: 'jyskebank' | 'nordea';
};

export const useGenericCombinedFinancing = ({
  heatPumpLoan,
  solarLoan,
  calculationMethod = 'nordea',
  selectedProductTypes: inputSelectedProductTypes,
  offer,
  residence,
}: GenericCombinedFinancingParameters) => {
  const { selectedProductTypes } = useSelectedProductTypesContext();

  const productTypes = inputSelectedProductTypes ?? selectedProductTypes;

  const { solarPanel, inverter, battery, heatPumpOutdoorUnit, heatPumpIndoorUnit } = offer ?? {};

  const heatPumpOffer = { heatPumpOutdoorUnit, heatPumpIndoorUnit };
  const solarOffer = { solarPanel, inverter, battery };

  const heatPumpFinancing = useGenericFinancing({
    loan: heatPumpLoan,
    products: heatPumpOffer,
    residence,
    calculationMethod,
  });

  const solarFinancing = useGenericFinancing({ loan: solarLoan, products: solarOffer, residence, calculationMethod });

  return getCombinedFinancing(getOutputArrayFilteredByProductType(productTypes, heatPumpFinancing, solarFinancing));
};
